import { AnyAction } from 'redux';
import { put } from 'redux-saga/effects';
import * as actions from '@/store/actions';
import { apiClient } from '@/utils';
import { AxiosResponse } from 'axios';

export function* fetchPriceViewTypes({ payload }: AnyAction) {
    try {
        const response: AxiosResponse = yield apiClient.get('/services/priceviewtypes', {});

        yield put(actions.FETCH_PRICE_VIEW_TYPES.success(response.data));
    } catch (error) {
        yield put(actions.FETCH_PRICE_VIEW_TYPES.failure(error));
    }
}

